import { BaseService } from '@services/BaseService'

const resource = 'hr/procedure'

class ProcedureService extends BaseService {
  constructor() {
    super(resource)
  }
}

export const procedureService = new ProcedureService()
